export var COMPANIES = {
    BLACKBIRD: "eu-west-1_aBWI4ripT",
    BLACKBIRD_STAGING: "eu-west-1_lu59lbvt7",
    BLACKBIRD_INTEGRATION: "eu-west-1_czfdxeBwy",
    DITSCH: "eu-west-1_M688EnDz3",
    LUNDBECK: "eu-west-1_rWr89Di8G",
    FERRING: "eu-west-1_2kFPCOGXt",
    VELUX: "eu-west-1_3HhFmTR7L",
    RADIOMETER: "eu-west-1_DXEVX3RNB",
    MCBRIDE_DENMARK: "eu-west-1_h1TPBWTrd",
    XELLIA: "eu-west-1_KbRYwcvBI",
    V2TOBACCO: "eu-west-1_Ra9pJi2OO",
    DANISHCROWN: "eu-west-1_bxV8gUV7N",
    CORO: "eu-west-1_k4M3gfCUR",
    "RADIOMETER-DK": "eu-west-1_RjzskH6Eb",
    VEGA_SALMON: "eu-west-1_Sg0oAgOqk"
};
export var USER_IDS = {
    FINN: "27b3fe61-3f26-449d-a880-8dd2b654e1e3"
};
export var SESSION_STORAGE_TOKEN = "SESSION_STORAGE_TOKEN";
export var COOKIE_SESSION_NAME = "assumeSession";
